module.exports = __webpack_public_path__ + "img/marker-oil-export-yellow.f8ef0c42.png";